/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import HoverSplash from './hoverSplash';

type PropsType = {
  p: {
    photos?: [],
    link_label: string,
    id: number
  }
};

const Photos = (props: PropsType): React.Element<'div'> => {
  const { p } = props;

  return (
    <div className={`splash-section splash-section-photos ${p.background_color === 'Light' ? 'splash_section_light' : 'splash_section_dark'}`} id={`${_.toLower(p.link_label)}${p.id}`}>
      <div className="splash-container">
        <h3 className="splash-section-title">Photos</h3>
        <div className="row full-image" data-bind="foreach:part.photos,css:{'full-image':part.photos().length==1 }">
          <div className="col col-sm-6 col-xs-12" data-bind="css:$parent.getColClass($index())">
            <div className="splash-image" data-bind="click:$parent.previewImage.bind($parent,$index(),$element)">
              <div className="splash-image-h" />
              <div className="splash-image-flex-container">
              {!!_.size(p.photos) &&
                <>
                  {_.map(
                    _.sortBy(p.photos, (_p: {}): number => _p.placement_index),
                    (ph: {}, phi: number): React.Element<'img'> => {
                    return (
                      <div key={`p.photos-${phi}`}>
                        <img
                          style={{
                            visibility: 'visible',
                            width: '100%',
                            height: 'auto'
                          }}
                          src={ph.url}
                        />
                      </div>
                    );
                  })}
                </>
              }
              </div>
            </div>
          </div>
        </div>
      </div>

      <HoverSplash {...props} />
    </div>
  );
};

export default Photos;
